"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FileInfoStatus = exports.FileInfoErrorType = void 0;
var FileInfoStatus = exports.FileInfoStatus = /*#__PURE__*/function (FileInfoStatus) {
  FileInfoStatus["IN_PROGRESS"] = "IN_PROGRESS";
  FileInfoStatus["CANCELLED"] = "CANCELLED";
  FileInfoStatus["ERROR"] = "ERROR";
  FileInfoStatus["COMPLETE"] = "COMPLETE";
  return FileInfoStatus;
}({});
var FileInfoErrorType = exports.FileInfoErrorType = /*#__PURE__*/function (FileInfoErrorType) {
  FileInfoErrorType["IMAGE_TOO_SMALL"] = "IMAGE_TOO_SMALL";
  FileInfoErrorType["WRONG_FILE_TYPE"] = "WRONG_FILE_TYPE";
  FileInfoErrorType["FILE_TOO_BIG"] = "FILE_TOO_BIG";
  FileInfoErrorType["NOT_IMAGE"] = "NOT_IMAGE";
  FileInfoErrorType["UNKNOWN"] = "UNKNOWN";
  FileInfoErrorType["INVALID_INPUT"] = "INVALID_INPUT";
  FileInfoErrorType["NETWORK_ERROR"] = "NETWORK_ERROR";
  FileInfoErrorType["INFO_NOT_LOADED"] = "INFO_NOT_LOADED";
  FileInfoErrorType["FILE_GROUP_CREATE_FAILED"] = "FILE_GROUP_CREATE_FAILED";
  FileInfoErrorType["FILE_DELETED"] = "FILE_DELETED";
  return FileInfoErrorType;
}({}); // type to fill in listeners and state